import { cpnjRegexFormat } from "./regexPatternsUtils";

export function convertDateStringToPtBrFormat(dateString: string) {
  const unformattedDate = new Date(dateString);
  const formattedDate = unformattedDate.toLocaleDateString("pt-Br");
  return formattedDate;
}

export function convertStringToCpnjFormat(cnpj: string) {
  const formattedCpnj = cnpj.replace(cpnjRegexFormat, "$1.$2.$3/$4-$5");
  return formattedCpnj;
}
